@if (project(); as project) {
  <div class="project-header" [class.health-metric-header]="isHealthMetrics()">
    <div class="flex justify-between">
      <div class="flex items-center gap-4 flex-wrap">
        @if (foundation()) {
          <div class="dropdown" [formGroup]="form">
            <p-treeselect
              formControlName="project"
              [options]="childProjects()"
              placeholder="Select a sub-project"
              styleClass="project-dropdown"
              [filter]="true"
              size="small"
              filterBy="label,data.Slug"
              appendTo="body"
              (onShow)="onShowProjects($event)"
              filterPlaceholder="Search sub-projects"></p-treeselect>
          </div>
        } @else {
          <p-skeleton width="150px" height="34px"></p-skeleton>
        }

        <div class="bookmark">
          <i class="fa-star fa-solid" appendTo="body" pTooltip="Bookmark" [ngClass]="isFavorite() ? 'active' : ''" (click)="onToggleFavorite()"></i>
        </div>
        <div class="project-status">
          <span [class]="project.Status | lowercase" [pTooltip]="project.Status | projectStageInfo" appendTo="body">{{
            project.Status === 'Prospect' ? 'Draft' : project.Status
          }}</span>
        </div>
      </div>
      @if (!isHealthMetrics()) {
        @if (permissions()) {
          <div class="flex flex-col lg:flex-row gap-2 items-center">
            @if (canCreateProjects()) {
              <button class="cta-button" (click)="onCreate()">
                <i class="fa-light fa-plus text-blue-light"></i>
                <span>Add Project</span>
              </button>
            }

            <button class="cta-button" routerLink="/all-projects">
              <i class="fa-light fa-layer-group text-blue-light"></i>
              <span>View All Projects</span>
            </button>

            @if (hasShowAuditLog()) {
              <button class="cta-button" (click)="toggleAuditLog()">
                <i class="fa-light fa-file text-blue-light"></i>
                <span>View Audit Log</span>
              </button>
            }
          </div>
        }
      }

      @if (isHealthMetrics() && showHealthTimeRange()) {
        <div class="flex flex-col items-end">
          <span class="text-13 font-robotoSlabBold font-bold">{{ pageTitle() }}</span>
          <lfx-health-metric-time-range></lfx-health-metric-time-range>
        </div>
      }
    </div>
  </div>

  @if (project.Status === 'Prospect') {
    <div class="draft-warning-container">
      <p-message severity="warn" icon="fa-solid fa-triangle-exclamation text-20">
        <div class="w-full flex justify-between items-center">
          <p class="text-13">
            This project is in a draft stage and some services will not be available. Projects in draft stage are regularly reviewed and approved in 3 to 5
            business days.
          </p>
          <a pButton class="p-button-secondary" [href]="escalateReviewLink()" target="_blank">Escalate Review</a>
        </div>
      </p-message>
    </div>
  }
}

<p-drawer [visible]="showAuditLog()" (visibleChange)="showAuditLog.set($event)" [blockScroll]="true" position="right" styleClass="!w-3/4">
  <ng-template pTemplate="header">AUDIT LOG</ng-template>
  <ng-template pTemplate="content">
    @if (hasCommitteeAuditLog()) {
      <lfx-committee-audit-log></lfx-committee-audit-log>
    }

    @if (hasProjectAuditLog()) {
      <lfx-activity-log></lfx-activity-log>
    }

    @if (hasMeetingAuditLog()) {
      <lfx-meeting-audit-log [meetingId]="meetingId()" [meetingTopic]="meetingTopic()" [isPastMeeting]="isPastMeeting()"> </lfx-meeting-audit-log>
    }
  </ng-template>
</p-drawer>
